var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new-modal-top-nav-center"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.headerImg,
      expression: "headerImg"
    }],
    class: [{
      'new-modal-top-nav-center-img-title': !_vm.headerTitle
    }, {
      'new-modal-top-nav-center-img-subtitle': _vm.headerTitle
    }],
    attrs: {
      "alt": _vm.headerTitle,
      "src": "".concat(_vm.assetsPath, "/images/common/customs_logo_red.png")
    }
  }), _vm.showStepsView ? _c('ugc-steps-view') : _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.headerTitle,
      expression: "headerTitle"
    }],
    attrs: {
      "id": "customs-vmodal-header-title"
    }
  }, [_vm._v(" " + _vm._s(_vm.headerTitle) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }